import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';

import Button from 'Mui/Button';
import Typography from '@material-ui/core/Typography';

import { system900 } from 'Mui/styles/color';
import { below } from 'utils/breakpoint';

function ErrorHint({ errorCode, isKKReducePointMode, onClose = () => {} }) {
    return (
        <>
            <div css={contentStyle}>
                <Typography variant="h6">{i18n.t('label.system_error_try_later')}</Typography>
                <Typography variant="h6">{errorCode}</Typography>
            </div>
            <div css={btnContainerStyle}>
                {isKKReducePointMode && (
                    <a
                        href="https://cs.kkbox.com/tw/index.php"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button variant="contained" css={successBtnStyle}>
                            {i18n.t('label.call_customer_service')}
                        </Button>
                    </a>
                )}
                <Button onClick={onClose} css={cancelBtnStyle}>
                    {i18n.t('btn.back')}
                </Button>
            </div>
        </>
    );
}

export default ErrorHint;

const contentStyle = css`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const btnContainerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
`;

const successBtnStyle = css`
    background: ${system900.color};
    color: #fff;
    &:hover {
        background: rgba(85, 85, 85, 0.8);
    }
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;

const cancelBtnStyle = css`
    margin-top: 8px;
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;
